import React from 'react';
import AppSidebar from '../components/AppSidebar/AppSidebar';
import ProjectsPage from '../components/Project/ProjectsPage/ProjectsPage';

export default function ProjectsLayout() {
  return (
    <AppSidebar>
      <ProjectsPage />
    </AppSidebar>
  );
}
